import React from 'react';
import Route from 'react-router/lib/Route';
import IndexRoute from 'react-router/lib/IndexRoute';
import MarketingLeads from './containers/MarketingLeads';
import Add from './containers/Add';
import Edit from './containers/Edit';

const Routes = (
  <Route path="marketing-leads">
    <IndexRoute component={MarketingLeads} />
    <Route path="add" component={Add} />
    <Route path=":id/edit" component={Edit} />
  </Route>
);

export default Routes;

